export class DataCatalogViewAiProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "trigger",
            "baseName": "trigger",
            "type": "string",
            "format": ""
        },
        {
            "name": "questionExamples",
            "baseName": "questionExamples",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "sourceSessionIds",
            "baseName": "sourceSessionIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "confidence",
            "baseName": "confidence",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogViewAiProperties.attributeTypeMap;
    }
    constructor() {
    }
}
